import { inject, Injectable } from '@angular/core';
import { LanguageStore } from '../../language.store';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import {
  requestCodeRequest,
  RequestTokenResponse,
  TokenResponse,
  ValidateStepResponse
} from '../dto';
import { IAuthHttpService } from './auth-http-service.interface';

@Injectable({
  providedIn: 'root'
})
export class AuthHttpService implements IAuthHttpService{
  private locale = inject(LanguageStore).currentLanguageCode();
  readonly http: HttpClient = inject(HttpClient);
  private readonly baseUrl = `${environment.apiBaseUrl}/${this.locale}/api/1.0/modules/acs/expat`;
  private readonly baseCommonUrl = `${environment.apiBaseUrl}/${this.locale}/api/1.0`;

  public postExchangeToken(data: { visitor_token: string }) {
    return this.http
      .post<RequestTokenResponse>(`${this.baseUrl}/exchange-token`, data)
      .pipe(map((value) => value.data.token_producer));
  }

  public postSendVerificationCode(param: { uuid: string; code: string }) {
    return this.http.post<ValidateStepResponse>(
      `${this.baseCommonUrl}/auth-with-code`,
      param
    );
  }

  public requestCode(uuid: string, data: requestCodeRequest) {
    return this.http.post<void>(`${this.baseCommonUrl}/request-code/${uuid}`, data);
  }
}
